import React from "react";
import { ScheduleDetailTemplate } from "../../Templates/ScheduleDetailTemplate";

export const ScheduleDetail = () => {
  return <ScheduleDetailTemplate />;
};
